// extracted by mini-css-extract-plugin
export default {"input":"EditableText_input__qwxqi","root":"EditableText_root__6dSTD","text":"EditableText_text__qaDou","inputWrapper":"EditableText_inputWrapper__d7vOQ"};